import { accMul } from "@/components/common/utils/math";

export function toThousands(num) {
	var result = '',
		counter = 0;
	num = (num || 0).toString();
	for (var i = num.length - 1; i >= 0; i--) {
		counter++;
		result = num.charAt(i) + result;
		if (!(counter % 3) && i != 0) {
			result = ',' + result;
		}
	}
	return result;
}

export function changeDecimal(x,d=2) {
	return Math.floor(x * Math.pow(10,d)) / Math. pow(10,d);
}

export function toPercent(num,d=1){
	return changeDecimal(accMul(num,100) ,d) + '%'
}

export function unitConversion(num) {
	if (num !== 0 && !num || isNaN(num)) {
		return '请传入数值格式的数据'
	}
	// 此处为防止字符串形式的数值进来，因为toFixed方法只能用于数值型数
	num = Number(num)
	if (Math.abs(num) > 100000000) {
		return (num / 100000000).toFixed(2) + '亿'
	} else if (Math.abs(num) > 10000) {
		// 始终保留
		return  (num / 10000).toFixed( 2) + '万'
	} else {
		return num
	}
}

export function unitConversion2(num) {
	if (num !== 0 && !num || isNaN(num)) {
		return '请传入数值格式的数据'
	}
	// 此处为防止字符串形式的数值进来，因为toFixed方法只能用于数值型数
	num = Number(num)
	if (Math.abs(num) >= 10000) {
		// 没有小数不保留
		return Math.round((num / 10000) * 100) / 100 + 'W'
	} else if (Math.abs(num) >= 1000) {
		// 没有小数不保留
		return Math.round((num / 1000) * 100) / 100 + 'K'
	}else {
		return num
	}
}

export function toChinesNum(num){
    let changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']; //changeNum[0] = "零"
    let unit = ["", "十", "百", "千", "万"];
    num = parseInt(num);
    let getWan = (temp) => {
    let strArr = temp.toString().split("").reverse();
    let newNum = "";
    for (var i = 0; i < strArr.length; i++) {
      newNum = (i == 0 && strArr[i] == 0 ? "" : (i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ? "" : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i]))) + newNum;
    }
     return newNum;
   }
   let overWan = Math.floor(num / 10000);
   let noWan = num % 10000;
   if (noWan.toString().length < 4) noWan = "0" + noWan;
   return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
}